import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=11f11b9c&scoped=true&"
import script from "./purchased.vue?vue&type=script&lang=js&"
export * from "./purchased.vue?vue&type=script&lang=js&"
import style0 from "./purchased.vue?vue&type=style&index=0&id=11f11b9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f11b9c",
  null
  
)

export default component.exports